import ProductBadge from 'data/ProductBadge';
import {
  BADGE_TEXT_MAX_LENGTH,
  BADGE_TEXT_REQUIRED,
  BADGE_TEXT_TOO_LONG,
  BADGE_TEXT_DUPLICATE,
  BADGE_COLOR_REQUIRED
} from 'constants/productBadges';

export const normalizeBadgeName = (text: string): string =>
  text.trim().replace(/\s+/g, ' ').toUpperCase();

export interface BadgeFormErrors {
  name?: string;
  colorHash?: string;
}

export const validateBadgeForm = (
  name: string,
  colorHash: string,
  existingBadges: ProductBadge[]
): BadgeFormErrors => {
  const errors: BadgeFormErrors = {};
  const normalized = normalizeBadgeName(name);

  if (!name.trim() || !normalized) {
    errors.name = BADGE_TEXT_REQUIRED;
  } else if (name.trim().length > BADGE_TEXT_MAX_LENGTH) {
    errors.name = BADGE_TEXT_TOO_LONG;
  } else if (existingBadges.some(badge => badge.isActive && badge.name === normalized)) {
    errors.name = BADGE_TEXT_DUPLICATE;
  }

  if (!colorHash) {
    errors.colorHash = BADGE_COLOR_REQUIRED;
  }

  return errors;
};

export const hasErrors = (errors: BadgeFormErrors): boolean => Object.values(errors).some(Boolean);
